
import React from 'react';
import { Card } from "@/components/ui/card";

interface DateDebuggerProps {
  dateValue: any;
  label: string;
}

export const DateDebugger: React.FC<DateDebuggerProps> = ({ dateValue, label }) => {
  // Don't process the date at all - just display it exactly as received
  const displayValue = dateValue ? String(dateValue) : 'No date';
  
  console.log(`DateDebugger - ${label}:`, {
    value: dateValue,
    type: typeof dateValue,
    stringValue: displayValue,
    isString: typeof dateValue === 'string',
    isNumber: typeof dateValue === 'number'
  });

  return (
    <Card className="p-2 m-2 bg-yellow-50 border-yellow-200">
      <div className="text-xs">
        <div><strong>{label}:</strong></div>
        <div>Value: {displayValue}</div>
        <div>Type: {typeof dateValue}</div>
        <div>Raw: {JSON.stringify(dateValue)}</div>
      </div>
    </Card>
  );
};
